import Navbar from 'organisms/Navbar';
import React from 'react';

const NavbarOnlyLayout = ({ children }) => {
  return (
    <div className="h-screen overflow-hidden flex flex-col">
      <Navbar />
      <div className="flex-1 overflow-x-hidden overflow-y-auto scrollbar">
        {children}
      </div>
    </div>
  );
};

export default NavbarOnlyLayout;
